import React, { useState } from 'react';
import RadioGroupCustomWithImage from './radioGroupCustomWithImage';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';

function ImageCheckBoxCustom(props) {
  const { member, isVE, imageUrls, onChange } = props;
  // let isFirstActive = false;
  // let isFirstLoad = true;
  // let display = 'd-none';
  // let display1 = '';
  // let isActive = false;

  const [isFirstActive, setIsFirstActive] = useState(false);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [display, setDisplay] = useState('d-none');
  const [display1, setDisplay1] = useState('');
  const [isActive, setIsActive] = useState(false);

  const checkDomainElement = () => {
    return member.domain.elements.length > 3;
  };

  const handleClick = () => {
    // display1 = 'd-none';
    // isFirstActive = true;
    setDisplay1('d-none');
    setIsFirstActive(true);
  };

  const handleClick2 = () => {
    // isFirstLoad = false;
    // display = 'd-none';
    // isFirstActive = true;
    // isActive = false;

    setIsFirstLoad(false);
    setDisplay('d-none');
    setIsFirstActive(true);
    setIsActive(false);
  };

  const handleViewMoreClick = () => {
    // isActive = true;
    // isFirstActive = false;
    // display = '';
    // isFirstLoad = false;

    setIsFirstLoad(false);
    setDisplay('');
    setIsFirstActive(false);
    setIsActive(true);
  };

  const handleViewLessClick = () => {
    // isActive = false;
    // isFirstActive = true;
    // display = 'd-none';

    setDisplay('d-none');
    setIsFirstActive(true);
    setIsActive(false);
  };

  return (
    <div className="image-control">
      {checkDomainElement() ? (
        <>
          {isFirstActive && (
            <RadioGroupCustomWithImage
              defaultValue={member.value}
              items={member.domain.elements.filter(x => x.name == member.value)}
              isVE={isVE}
              imageUrls={imageUrls}
              onChange={onChange}
            />
          )}
          {isFirstLoad && (
            <>
              {member.alwaysCommitted ? (
                <RadioGroupCustomWithImage
                  defaultValue={member.value}
                  items={member.domain.elements.filter(x => x.selected == true)}
                  isVE={isVE}
                  imageUrls={imageUrls}
                  onChange={onChange}
                />
              ) : (
                <div className={display1}>
                  <RadioGroupCustomWithImage
                    defaultValue={member.value}
                    items={member.domain.elements.slice(0, 3)}
                    isVE={isVE}
                    imageUrls={imageUrls}
                    onChange={onChange}
                    handleClick={handleClick}
                  />
                </div>
              )}
            </>
          )}
          <div className={display}>
            <RadioGroupCustomWithImage
              defaultValue={member.value}
              items={member.domain.elements}
              isVE={isVE}
              imageUrls={imageUrls}
              onChange={onChange}
              handleClick={handleClick2}
            />
          </div>
        </>
      ) : (
        <RadioGroupCustomWithImage
          defaultValue={member.value}
          items={member.domain.elements}
          isVE={isVE}
          imageUrls={imageUrls}
          onChange={onChange}
        />
      )}
      {checkDomainElement() &&
        (!isActive ? (
          <div onClick={() => handleViewMoreClick()} className="action">
            <AddIcon className="action-icon" /> View More
          </div>
        ) : (
          <div onClick={() => handleViewLessClick()} className="action">
            <RemoveIcon className="action-icon" /> View Less
          </div>
        ))}
    </div>
  );
}

export default ImageCheckBoxCustom;
